import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/31.png';
import _imports_1 from '../../../assets/new/42.png';
import _imports_2 from '../../../assets/new/49.png';
import _imports_3 from '../../../assets/new/9.png';
import _imports_4 from '../../../assets/new/51.png';
const _withScopeId = n => (_pushScopeId("data-v-24709848"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  class: "day"
};
const _hoisted_6 = {
  class: "week"
};
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"articles\" data-v-24709848><div class=\"number\" data-v-24709848><span data-v-24709848>当日共<i data-v-24709848>3</i>篇文章</span><span data-v-24709848>已完成0篇</span></div><div class=\"articlesList\" data-v-24709848><div class=\"line\" data-v-24709848></div><div class=\"item\" data-v-24709848><div data-v-24709848><div class=\"circular\" data-v-24709848></div><div class=\"line\" data-v-24709848></div></div><div data-v-24709848>初级</div><a href=\"javascript: void(0)\" data-v-24709848><h4 data-v-24709848>高三英语第一单元阅读</h4><div data-v-24709848><img src=\"" + _imports_1 + "\" data-v-24709848><span data-v-24709848>主讲：Uan</span></div></a></div><div class=\"item\" data-v-24709848><div data-v-24709848><div class=\"circular\" data-v-24709848></div><div class=\"line\" data-v-24709848></div></div><div data-v-24709848>中级</div><a href=\"javascript: void(0)\" data-v-24709848><h4 data-v-24709848>高三英语第一单元阅读</h4><div data-v-24709848><img src=\"" + _imports_1 + "\" data-v-24709848><span data-v-24709848>主讲：Uan</span></div></a></div><div class=\"item\" data-v-24709848><div data-v-24709848><div class=\"circular\" data-v-24709848></div><div class=\"line\" data-v-24709848></div></div><div data-v-24709848>高级</div><a href=\"javascript: void(0)\" data-v-24709848><h4 data-v-24709848>高三英语第一单元阅读</h4><div data-v-24709848><img src=\"" + _imports_1 + "\" data-v-24709848><span data-v-24709848>主讲：Uan</span></div></a></div></div></div><a href=\"javascript: void(0)\" class=\"all\" data-v-24709848>查看全部文章 &gt;</a>", 2);
const _hoisted_9 = {
  key: 0,
  style: {
    "height": "6rem"
  }
};
const _hoisted_10 = {
  key: 1,
  style: {
    "height": "6rem",
    "width": "750px",
    "background": "#fff"
  }
};
const _hoisted_11 = {
  class: "footer"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
import { Swiper, SwiperSlide } from "swiper/vue";
import { useRouter } from "vue-router";
import "swiper/css";
import { reactive, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { getLocalPid } from "../../../libs/util";
import { ElMessage } from "element-plus";
import { articleListPlan } from "../../../api/index";
export default {
  __name: 'plan_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const store = useStore();
    const pid = getLocalPid();
    const router = useRouter();
    const token = computed(() => store.state.token);
    const userId = computed(() => store.state.userId);
    const sign = computed(() => store.state.sign);
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const today = date.getDate();
    const onSwiper = swiper => {
      swiper.slideTo(today - 4);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    const weekDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    let week = new Date(`${year}-${month + 1}`).getDay();
    const data = reactive({
      days: [],
      articleData: {}
    });
    for (let i = 1; i <= new Date(year, month + 1, 0).getDate(); i++) {
      data.days.push({
        day: i,
        week: weekDays[week],
        active: i === today
      });
      if (week === 6) {
        week = 0;
      } else {
        week++;
      }
    }
    const request30DaysArticles = () => {
      let obj = {
        token: token.value,
        sign: sign.value,
        userId: userId.value,
        pid: getLocalPid()
      };
      articleListPlan(JSON.stringify(obj)).then(res => {
        data.articleData = res.data.data;
        console.log(data.articleData);
      }).catch(() => {
        ElMessage.error("获取文章列表失败 请稍后再试");
      });
    };
    onMounted(() => {
      request30DaysArticles();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).go(-1))
      }, _hoisted_4), _createTextVNode(" 我的阅读计划 ")]), _createVNode(_unref(Swiper), {
        "slides-per-view": 7,
        "space-between": 0,
        onSwiper: onSwiper,
        onSlideChange: onSlideChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.days, (item, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["wrapper", {
                active: item.active
              }])
            }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.day), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item.week), 1)])], 2)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]), _hoisted_7, isMobile.value ? (_openBlock(), _createElementBlock("div", _hoisted_9)) : (_openBlock(), _createElementBlock("div", _hoisted_10)), _createElementVNode("div", _hoisted_11, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push({
          name: 'index',
          query: {
            pid: _unref(pid)
          }
        }))
      }, [_hoisted_12, _createTextVNode(" 原版阅读 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push({
          name: 'photo',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_13, _createTextVNode(" AI工具 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        style: {
          "color": "#35b9ff"
        },
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'my',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_14, _createTextVNode(" 个人中心 ")])])], 2);
    };
  }
};